<template>
  <offer-question-form :id="id" />
</template>

<script>
import OfferQuestionForm from "./OfferQuestionForm.vue";

export default {
  components: { OfferQuestionForm },
  props: {
    id: { type: String, required: true },
  },
};
</script>
